<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-btn color="primary" dark @click="dialog = true"
        >عمل فاتورة مباشرة</v-btn
      >
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="orange">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>اغلاق</v-toolbar-title>
            <v-toolbar-title>اضافة فاتورة عميل</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            فاتورة بيع جديدة
            <!-- <v-btn color="blue">فاتورة جديدة</v-btn> -->
            <!-- <v-btn color="blue">فاتورة قديمة</v-btn> -->
            <v-flex xs12 sm6 md2>
              <v-text-field
                height="10"
                outline
                @keyup.enter="search_client_by_code"
                v-model="client_search_name"
                label="كود العميل"
              ></v-text-field>
            </v-flex>
            <v-autocomplete
              v-model="select_client"
              :items="clients"
              :hint="
                `${
                  select_client.mandob_sales
                    ? select_client.mandob_sales.name
                    : ''
                }- ${
                  select_client.mohafza ? select_client.mohafza.name : ''
                }- ${select_client.city ? select_client.city.name : ''}- ${
                  select_client.region ? select_client.region.name : ''
                }- ${select_client.branch ? select_client.branch.name : ''}`
              "
              label="اختر العميل "
              persistent-hint
              prepend-icon="mdi-city"
              return-object
              item-text="name"
              @change="change_client_name"
            >
              <template v-slot:append-outer>
                <v-slide-x-reverse-transition mode="out-in">
                </v-slide-x-reverse-transition>
              </template>
            </v-autocomplete>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="dialog = false">حفظ</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-card>
              <v-card-text>
                <v-form ref="form">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          height="10"
                          outline
                          disabled
                          v-model="mycode"
                          label="كود الفاتورة"
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.code')"
                          data-vv-name="code"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          disabled
                          v-model="select_client.code"
                          label="كود العميل "
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.price')"
                          data-vv-name="name"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-autocomplete
                          outline
                          v-model="select_client"
                          :items="clients"
                          :hint="
                            `${
                              select_client.mandob_sales
                                ? select_client.mandob_sales.name
                                : ''
                            }- ${
                              select_client.mohafza
                                ? select_client.mohafza.name
                                : ''
                            }- ${
                              select_client.city ? select_client.city.name : ''
                            }- ${
                              select_client.region
                                ? select_client.region.name
                                : ''
                            }- ${
                              select_client.branch
                                ? select_client.branch.name
                                : ''
                            }`
                          "
                          item-text="name"
                          item-value="id"
                          label="أختر العميل "
                          persistent-hint
                          return-object
                          single-line
                          @change="change_client_name"
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          outline
                          disabled
                          :value="
                            select_client.mandob_sales &&
                            select_client.mandob_sales_id != ''
                              ? select_client.mandob_sales.name
                              : ''
                          "
                          label="مندوب المبيعات"
                        ></v-text-field>
                      </v-flex>
                      <!-- <v-flex xs12 sm6 md2>
                    <v-text-field  outline disabled :value="select_client.mandob_taworid && select_client.mandob_taworid_id != '' ? select_client.mandob_taworid.name:''" label="مندوب التوزيع"  ></v-text-field>
                  </v-flex> -->
                      <v-flex xs12 sm6 md2>
                        <v-select
                          outline
                          v-model="select_mandob_tawzi3"
                          :items="mandobs_tawzi3"
                          item-text="name"
                          item-value="id"
                          label="مندوب التوزيع للفاتورة"
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="
                            errors.collect('form1.mandobs_tawzi3')
                          "
                          data-vv-name="mandobs_tawzi3"
                          data-vv-scope="form1"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          disabled
                          outline
                          v-model="select_client.rasid_efttahi"
                          label="الافتتاحي"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          disabled
                          v-model="select_client.had_eetmani"
                          label="حد ائتمان"
                          v-validate="'required'"
                          :error-messages="
                            errors.collect('form1.fatwora_final_price')
                          "
                          data-vv-name="fatwora_final_price"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-select
                          outline
                          v-model="select_sadad_type"
                          :items="m_sadad_types"
                          item-text="name"
                          item-value="id"
                          label="نوع السداد"
                          persistent-hint
                          return-object
                          single-line
                          @change="change_sadad_name"
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        ></v-select>
                      </v-flex>
                      <!-- <v-flex xs12 sm6 md1>
                    <v-select
                    outline
                    v-model="select_sadadstatuses"
                    :items="sadadstatuses"
                    item-text="name"
                    item-value="id"
                    label="حالة السداد"
                    persistent-hint
                    return-object
                    single-line
                     v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')" data-vv-name="manger" data-vv-scope="form1"
                ></v-select>
                  </v-flex>
  -->
                      <!-- <v-flex xs12 sm6 md2>
                    <v-text-field  outline disabled v-model="newItem.emp_sales_response_name" label="   اسم الموظف " v-validate="'required'"
                        :error-messages="errors.collect('form1.emp_sales_response_name')" data-vv-name="emp_sales_response_name" data-vv-scope="form1"></v-text-field>
                  </v-flex> -->
                      <v-flex xs12 sm6 md2>
                        <v-dialog
                          ref="dialog2"
                          v-model="modal2"
                          :return-value.sync="date2"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="date2"
                              label=" التاريخ اليدوي"
                              readonly
                              outline
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date2" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal2 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog2.save(date2)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="date"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="date"
                              label="تاريخ التسليم"
                              readonly
                              outline
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog.save(date)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-select
                          outline
                          v-model="select_store"
                          :items="stores"
                          item-text="name"
                          item-value="id"
                          label="أختر  المخزن "
                          persistent-hint
                          return-object
                          single-line
                          @change="get_items_of_store"
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md5>
                        <v-autocomplete
                          v-model="select_item"
                          :items="m_items"
                          item-text="name"
                          item-value="id"
                          label="أختر الصنف"
                          persistent-hint
                          prepend-icon="mdi-city"
                          return-object
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          :value="
                            select_item.now
                          "
                          disabled
                          label="المتاح"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          :disabled="select_item.id == ''"
                          type="number"
                          v-model="item_num"
                          label="العدد"
                          @change="
                            check_max(item_num, select_item.store_item.quantity)
                          "
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          :disabled="select_item.id == ''"
                          type="number"
                          v-model="item_bonus"
                          label="البونص"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          disabled
                          v-model="get_item_num_after"
                          label="العدد بعد"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          :disabled="select_item.id == ''"
                          type="number"
                          v-model="price"
                          label="السعر"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          disabled
                          v-model="gettotalpriceitem"
                          label="السعر الكلي"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          outline
                          :disabled="select_item.id == ''"
                          type="number"
                          v-model="item_discount"
                          label="الخصم"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          outline
                          disabled
                          v-model="get_item_final_price"
                          label="السعر النهائي للصنف"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-btn
                          color="orange"
                          :disabled="select_item.id == ''"
                          @click="add_item"
                          >اضف الصنف</v-btn
                        >
                      </v-flex>
                    </v-layout>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-divider class=" my-1" inset horizontal></v-divider>

                    <v-data-table
                      :headers="headers7"
                      :items="added_items"
                      class="elevation-1"
                      :search="search"
                      :loading="loading"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <v-btn
                            style="width: 50px;"
                            @click="remove_item(props.item)"
                            ><v-icon>delete</v-icon></v-btn
                          >
                        </td>
                        <td>{{ props.item.item_name }}</td>
                        <td>{{ props.item.item_num }}</td>
                        <td>{{ props.item.price }}</td>
                        <td>{{ props.item.total_price }}</td>
                        <td>{{ props.item.item_num_before }}</td>
                        <td>{{ props.item.item_discount }}</td>
                        <td>{{ props.item.item_bonus }}</td>
                        <td>{{ props.item.item_num_after }}</td>
                        <td>{{ props.item.final_price }}</td>
                      </template>
                    </v-data-table>

                    <v-layout>
                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          outline
                          disabled
                          v-model="fatwora_price"
                          label="السعر الاجمالي للفاتورة "
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.price')"
                          data-vv-name="name"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          outline
                          v-model="newItem.discount"
                          label=" الخصم للفاتورة "
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          outline
                          disabled
                          v-model="fatwora_final_price"
                          label=" السعر النهائي للفاتورة  "
                          v-validate="'required'"
                          :error-messages="
                            errors.collect('form1.fatwora_final_price')
                          "
                          data-vv-name="fatwora_final_price"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          outline
                          disabled
                          v-model="newItem.madionia_sabqa"
                          label="  المديونية قبل الفاتورة"
                          v-validate="'required'"
                          :error-messages="
                            errors.collect('form1.madionia_sabqa')
                          "
                          data-vv-name="madionia_sabqa"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          outline
                          disabled
                          v-model="madionia_now"
                          label="المديونية بعد الفاتورة"
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.madionia_now')"
                          data-vv-name="madionia_now"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
                <v-btn color="blue darken-1" flat @click="save('form2')"
                  >حفظ</v-btn
                >
              </v-card-actions>
              <v-layout> </v-layout>
            </v-card>
          </v-list>
        </v-card>
      </v-dialog>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td class="text-xs-right">
              {{ props.item.store ? props.item.store.name : "" }}
            </td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="detailItem(props.item)">
                book
              </v-icon>
            </td>
            <td style="padding:0px">
              <v-btn color="orange" @click.prevent="tanfiz_confirm(props.item)">
                <!-- @click="confirm_fatwora" -->
                تاكيد الفاتورة
              </v-btn>
            </td>
            <td>
              {{ props.item.reason }}
            </td>
            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>
            <td>
              <v-icon
                style="curser:pointer"
                v-if="permissions.delete_all == 1 || user.type == 1"
                @click="delete_fatwora(props.item)"
                >delete</v-icon
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>

      الفواتير التي تم التأكد عليها من قبل
      <v-data-table
        :headers="headers22"
        :items="all_fatworas"
        class="elevation-1"
        :loading="loading"
        :pagination.sync="pagination2"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td class="text-xs-right">
              {{ props.item.store ? props.item.store.name : "" }}
            </td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="detailItem(props.item)">
                book
              </v-icon>
            </td>
            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination2.page"
          :length="pages2"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>

      <v-dialog v-model="detail_dialog" width="800" dark style="padding:10px">
        <v-card>
          <v-card-title class="headline orange lighten-2" primary-title>
            تفاصيل الفاتورة
          </v-card-title>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                الكود :
                {{ item_detail.code }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                المندوب :
                {{
                  item_detail.client && item_detail.client.mandob_sales
                    ? item_detail.client.mandob_sales.name
                    : ""
                }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                اسم العميل :
                {{ item_detail.client_name }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                السعر قبل :
                {{ item_detail.price_before }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                السعر بعد :
                {{ item_detail.price_after }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                نوع السداد :
                {{ item_detail.sdad_type_name }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                موظف عمل الفاتورة :
                {{ item_detail.emp_create_fatwora }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                تاريخ التسليم :
                {{ item_detail.taslim_date }}
              </v-flex>
              <v-flex xs12 sm6 md2>
                التاريخ
                <br />
                {{ item_detail.created_at }}
              </v-flex>
            </v-layout>
            <hr />
            <v-data-table
              :headers="headers3"
              :items="item_detail.fatwora_items"
              class="elevation-1"
              :rows-per-page-items="rowsPerPageItems"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.item_name }}</td>
                <td>{{ props.item.item_num }}</td>
                <td>{{ props.item.item_num_after }}</td>
                <td>{{ props.item.item_bonus }}</td>
              </template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="detail_dialog = false">
              موافق
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {
  tanfiz_confirm,
  add_fatwora,
  delete_fatwora,
  items_of,
  madionia_client,
  search_client_by_code,
  delete_fatwora_client_before_store,
  orders_and_fatwora_page,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    modal3: false,
    date3: new Date().toISOString().substr(0, 10),
    item_detail: {},
    detail_dialog: false,
    fatwora_id: "0",

    select_sadad_type: { id: "", job_name: "", name: "أختر نوع السداد" },
    select_client: { id: "", job_name: "", name: "أختر العميل" },
    select_employer: { id: "", job_name: "", name: "أختر المسئول" },
    select_store: { id: "", job_name: "", name: "أختر المخزن" },
    select_item: { id: "", job_name: "", name: "أختر الصنف" },
    select_sadadstatuses: { name: "" },
    select_mandob_tawzi3: {},
    mandobs_tawzi3: [],

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    pagination2: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: " اسم العميل", value: "client_name", align: "right" },
      { text: "  التاريخ ", value: "taslim_date", align: "right" },
      { text: "  تاريخ التسليم", value: "taslim_date", align: "right" },
      { text: " المخزن", value: "store", sortable: false, align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " تأكيد", value: "store", sortable: false, align: "right" },
      { text: " سبب الرفض", value: "store", sortable: false, align: "right" },
      { text: " فحص وطباعة", value: "store", sortable: false, align: "right" },
      { text: " حذف", value: "store", sortable: false, align: "right" }
    ],
    headers22: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: " اسم العميل", value: "client_name", align: "right" },
      { text: "  التاريخ ", value: "taslim_date", align: "right" },
      { text: "  تاريخ التسليم", value: "taslim_date", align: "right" },
      { text: " المخزن", value: "store", sortable: false, align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " فحص وطباعة", value: "store", sortable: false, align: "right" }
    ],
    headers7: [
      {
        text: "حذف ",
        align: "right",
        sortable: false
      },
      {
        text: "الصنف ",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: "العدد", value: "phone", sortable: false, align: "right" },
      { text: " السعر", value: "price", sortable: false, align: "right" },
      {
        text: " السعر الكلي",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: "  العدد قبل",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: "  الخصم",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " البونص ",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " العدد بعد ",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " السعر النهائي",
        value: "total_price",
        sortable: false,
        align: "right"
      }
    ],
    headers8: [
      {
        text: "الصنف ",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: "العدد", value: "phone", sortable: false, align: "right" },
      { text: " السعر", value: "price", sortable: false, align: "right" },
      {
        text: " السعر الكلي",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: "  العدد قبل",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: "  الخصم",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " البونص ",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " العدد بعد ",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " السعر النهائي",
        value: "total_price",
        sortable: false,
        align: "right"
      }
    ],
    headers5: [
      {
        text: "حذف ",
        align: "right",
        value: "code"
      },
      { text: "الصنف ", value: "price_after", align: "right" },
      { text: "العدد", value: "client_name", align: "right" },
      { text: "السعر", value: "taslim_date", align: "right" },
      { text: "السعر الكلي", value: "taslim_date", align: "right" },
      { text: " العدد قبل", value: "store", sortable: false, align: "right" },
      { text: " خصم", value: "store", sortable: false, align: "right" },
      { text: " بونص", value: "store", sortable: false, align: "right" },
      { text: "السعر النهائي", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: " العدد النهائي",
        value: "item_num_after",
        sortable: false,
        align: "right"
      },
      {
        text: "   البونص",
        value: "item_bonus",
        sortable: false,
        align: "right"
      }
    ],

    fatworas: [],
    all_fatworas: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    m_items: [],
    stores: [],
    client_search_name: "",
    sadadstatuses: [],
    madionia_sabqa_of_madionia: "",
    newItem: {
      id: "",
      code: "",
      madionia_sabqa: "",
      madionia_now: "",
      discount: "",
      price_before: "",
      price_after: "",
      remain: "",
      sdad_type_name: "",
      sdad_status: "",
      sdad_status_id: "",
      emp_create_fatwora: "",
      emp_sales_response_name: "",
      client_name: "",
      taslim_date: "",
      store_id: "",
      sadad_type_id: "",
      client_id: "",
      emp_sales_response_id: "",
      created_at: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      client_id: "",
      emp_id: ""
    },
    added_items: [],
    item_num_before: "",
    item_num: "",
    item_num_after: "",
    item_discount: "",
    item_bonus: "",
    price: "",
    total_price: "",
    final_price: ""
  }),

  computed: {
    mycode() {
      if (this.fatworas.length > 0) {
        return (this.code =
          parseInt(this.fatworas[this.fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    pages2() {
      if (
        this.pagination2.rowsPerPage == null ||
        this.pagination2.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination2.totalItems / this.pagination2.rowsPerPage
      );
    },
    gettotalpriceitem() {
      if (this.item_num != "" && this.price != "") {
        this.total_price = parseInt(this.item_num) * parseFloat(this.price);
        return this.total_price;
      } else {
        return (this.total_price = 0);
      }
    },
    get_item_num_after() {
      if (this.item_bonus != 0 && this.item_bonus != null && this.item_bonus) {
        this.item_num_after =
          parseInt(this.item_num) + parseFloat(this.item_bonus);
        return this.item_num_after;
      } else if (this.item_num != "") {
        return (this.item_num_after = parseInt(this.item_num));
      } else {
        return (this.item_num_after = 0);
      }
    },
    get_item_final_price() {
      if (
        this.item_discount != "" &&
        this.item_discount != null &&
        this.item_discount
      ) {
        this.final_price =
          parseFloat(this.total_price) - parseFloat(this.item_discount);
        return this.final_price;
      } else if (this.total_price != "") {
        return (this.final_price = this.total_price);
      } else {
        return (this.final_price = 0);
      }
      return (this.final_price = parseFloat(this.total_price));
    },

    fatwora_price() {
      let tot_price = 0;
      for (let index = 0; index < this.added_items.length; index++) {
        tot_price += parseFloat(this.added_items[index].final_price);
      }
      return (this.newItem.price_before = tot_price);
    },
    fatwora_final_price() {
      if (this.newItem.price_before != "" && this.newItem.discount != "") {
        return (this.newItem.price_after =
          parseFloat(this.newItem.price_before) -
          parseFloat(this.newItem.discount));
      }
      return (this.newItem.price_after = this.newItem.price_before);
    },
    madionia_now() {
      if (this.newItem.price_after > 0) {
        return (this.newItem.madionia_now =
          parseFloat(this.madionia_sabqa_of_madionia) +
          parseFloat(this.newItem.price_after));
      }
      return (this.newItem.madionia_now = this.madionia_sabqa_of_madionia);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));

    orders_and_fatwora_page().then(response => {
      this.fatworas = response.data.tanfiz_fatworas;
      this.all_fatworas = response.data.after_tanfiz_fatworas;

      this.pagination.totalItems = response.data.tanfiz_fatworas.length;
      this.pagination2.totalItems = response.data.after_tanfiz_fatworas.length;
      this.loading = false;
    });
  },

  methods: {
    check_max(item, q) {
      //  let index = this.client_fatwora_reback_items.indexOf(item);
      if (parseInt(item) > parseInt(q)) {
        alert("لا يجوز ادخال قيمة اكبر من العدد المتاح");
        this.item_num = q;
      }
      if (parseInt(item) < 0) {
        alert("لا يجوز ادخال قيمة اقل من الواحد ");
        this.item_num = 1;
      }
    },
    initialize() {},

    add_item() {
      if (this.select_item.name) {
        this.added_items.push({
          item_name: this.select_item.name,
          item_num_before: this.item_num,
          item_num: this.item_num,
          item_num_after: this.item_num_after,
          item_discount: this.item_discount,
          item_bonus: this.item_bonus,
          price: this.price,
          total_price: this.total_price,
          final_price: this.final_price,
          item_id: this.select_item.id
        });
        this.select_item = { id: "" };
        this.item_num = "";
        this.item_num_after = "";
        this.item_discount = "";
        this.item_bonus = "";
        this.price = "";
        this.total_price = "";
        this.final_price = "";
      }
    },
    remove_item(item) {
      const index = this.added_items.indexOf(item);
      this.added_items.splice(index, 1);
    },
    change_client_name() {
      this.newItem.client_name = this.select_client.name;
      madionia_client(this.select_client.id).then(response => {
        this.newItem.madionia_sabqa = response.data.madionia;
        this.madionia_sabqa_of_madionia = response.data.madionia;
      });
    },
    change_employer_name() {
      this.newItem.emp_sales_response_name = this.select_employer.name;
    },
    change_sadad_name() {
      this.newItem.sdad_type_name = this.select_sadad_type.name;
    },
    change_sadad_name_edit() {
      this.edit_fatwora.sdad_type_name = this.select_sadad_type_edit.name;
    },
    get_items_of_store() {
      this.loading = true;
      this.items_of_old_fatwora = [];

      items_of(this.select_store.id).then(response => {
        this.m_items = response.data;
        this.loading = false;
      });
    },
    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_fatwora(frmData2, item.id).then(response => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (
          valid &&
          this.code != "" &&
          this.select_sadad_type.id != "" &&
          this.select_client.id != "" &&
          this.added_items.length > 0 &&
          this.select_store.id != ""
        ) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.sadad_type_id = this.select_sadad_type.id;
          this.newItem.client_id = this.select_client.id;
          // this.newItem.emp_sales_response_id = myUser.id;
          this.newItem.emp_sales_response_id = this.select_mandob_tawzi3.id;
          this.newItem.emp_sales_response_name = this.select_mandob_tawzi3.name;
          this.newItem.store_id = this.select_store.id;
          this.newItem.sdad_status = "غير مسددة";
          this.newItem.sdad_status_id = "2";
          this.newItem.taslim_date = this.date;
          this.newItem.created_at = this.date2;
          this.newItem.status = "1";
          this.newItem.emp_create_fatwora = myUser.name;
          this.newItem.emp_fatwora_tanfiz = myUser.name;
          this.newItem.remain = this.newItem.price_after;
          this.newItem.madionia_now = this.madionia_now;

          this.madionia.madionia_before = this.madionia_sabqa_of_madionia;
          this.madionia.cost_or_money = this.newItem.price_after;
          this.madionia.madionia_after =
            parseFloat(this.madionia_sabqa_of_madionia) +
            parseFloat(this.newItem.price_after);
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "fatwora";
          this.madionia.code_of_operation = this.newItem.code;
          this.madionia.client_id = this.select_client.id;
          this.madionia.emp_id = myUser.id;

          var frmData = new FormData();
          frmData.append("fatwora", JSON.stringify(this.newItem));
          frmData.append("fatwora_items", JSON.stringify(this.added_items));
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_fatwora(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_sadad_type, this.$options.data().select_sadad_type);
            // Object.assign(this.$data.select_client, this.$options.data().select_client);
            // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
            // Object.assign(this.$data.added_items, this.$options.data().added_items);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);
            // this.fatworas.push(response.data);
            this.loading = false;
            if (response.data.status == "false") {
              let mytitle1 = "لا يمكن عمل الفاتورة ";
              let mybody1 =
                "حيث ان مديونية العميل بالاضافة لقيمة الفاتورة ومجموعهم" +
                response.data.total +
                "اكبر من الحد الأئتماني وهو   " +
                response.data.had_eetmani;
              this.$toastr.warning(mybody1, mytitle1, {
                closeButton: true,
                progressBar: true,
                positionClass: "toast-bottom-left",
                preventDuplicates: false,
                timeOut: "250000"
              });

              return;
            }
            this.fatwora_id = response.data.fatwora.id;
            // this.close();
            let myUser = JSON.parse(localStorage.getItem("user"));
            var frmData3 = new FormData();
            frmData3.append("title", "اضافة فاتورة مباشرة");
            frmData3.append(
              "body",
              " - تم اضافة فاتورة بكود -" +
                this.newItem.code +
                "- لعميل - " +
                this.select_client.name +
                "- بواسطة -" +
                myUser.name +
                "- قيمتها -" +
                this.newItem.final_price +
                " - "
            );
            frmData3.append("type", "sell_fatwora");
            frmData3.append("user_id", myUser.id);
            log_me(frmData3).then(response => {
              if (response.data == true) {
                let mytitle = "اضافة فاتورة مباشرة";
                let mybody =
                  " -تم اضافة فاتورة بكود -" +
                  this.newItem.code +
                  "- لعميل - " +
                  this.select_client.name +
                  "- بواسطة -" +
                  myUser.name +
                  "- قيمتها -" +
                  this.newItem.final_price +
                  " -";
                this.$toastr.warning(mybody, mytitle, {
                  closeButton: true,
                  progressBar: true,
                  positionClass: "toast-bottom-left",
                  preventDuplicates: false,
                  timeOut: "25000"
                });
              }
              // setInterval(() => {
              //   this.printDiv("print_again");
              // }, 1000);
              this.$router.push("/FinalFatworasPrint/" + this.fatwora_id);
            });
          });
        }
      });
    },

    search_client_by_code() {
      search_client_by_code(this.client_search_name).then(response => {
        this.select_client = response.data;
        this.change_client_name();
      });
    },

    tanfiz_confirm(item) {
      var frmData = new FormData();
      let myUser = JSON.parse(localStorage.getItem("user"));
      frmData.append("emp_fatwora_tanfiz", myUser.name);
      this.loading = true;
      tanfiz_confirm(item.id, frmData).then(response => {
        this.loading = false;
        if (response.data.status == "false") {
          let mytitle1 = "لا يمكن عمل الفاتورة ";
          let mybody1 =
            "حيث ان مديونية العميل بالاضافة لقيمة الفاتورة ومجموعهم" +
            response.data.total +
            "اكبر من الحد الأئتماني وهو   " +
            response.data.had_eetmani;
          this.$toastr.warning(mybody1, mytitle1, {
            closeButton: true,
            progressBar: true,
            positionClass: "toast-bottom-left",
            preventDuplicates: false,
            timeOut: "250000"
          });

          return;
        }
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "التاكيد علي فاتورة في حالة قيد التنفيذ");
        frmData3.append(
          "body",
          "تم التاكيد علي فاتورة في حالة قيد التنفيذ " +
            this.select_store.name +
            " لفاتورة بكود " +
            item.code +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "tanfiz_accept");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "التاكيد علي فاتورة في حالة قيد التنفيذ";
            let mybody =
              "تم التاكيد علي فاتورة في حالة قيد التنفيذ  " +
              this.select_store.name +
              " لفاتورة بكود " +
              item.code +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }

          setTimeout(() => {
            this.$router.go(0);
          }, 3000);
        });
      });
    },
    detailItem(order) {
      this.item_detail = order;
      this.detail_dialog = true;
    },

    delete_fatwora(item) {
      this.$swal({
        title:
          "شرط لحذف الفاتورة ان تكون اخر فاتورة لنفس العميل حتي لا تؤثر علي المديونية ..هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          delete_fatwora_client_before_store(item.id).then(res => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    printDiv(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;

      document.body.classList.add("rtl");
      document.body.innerHTML = printContents;

      window.print();
      document.body.innerHTML = originalContents;
      return false;
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
.p_print {
  padding: 15px 10px;
  font-size: 18px;
}
</style>
